import { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import axios from "axios";
import CatalogTabPanel from "../shared/CatalogTabPanel";
import {
	getThreadRowId,
	threadAutoPrimaryKeyCatalogs,
	threadCatalogColumns,
	threadCatalogPrimaryKeys,
	threadCatalogTabs,
	threadCreatableFields,
	threadEditableFields,
} from "./data";

const API_BASE = "/api/sourcing/thread_master";

const ThreadMaster = () => {
	const [activeTab, setActiveTab] = useState(threadCatalogTabs[0].key);
	const [kpi, setKpi] = useState({});
	const [refreshKey, setRefreshKey] = useState(0);

	const fetchSummary = async () => {
		const res = await axios.post(`${API_BASE}/summary`);
		setKpi(res.data?.result?.kpi ?? {});
	};

	useEffect(() => {
		fetchSummary().catch(() => {});
	}, []);

	const handleSummaryRefresh = () => {
		fetchSummary().catch(() => {});
		setRefreshKey((prev) => prev + 1);
	};

	return (
		<Box
			sx={{
				height: "calc(100vh - 135px)",
				p: 1,
				boxSizing: "border-box",
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}>
			<Tabs
				value={activeTab}
				onChange={(_event, value) => setActiveTab(value)}
				variant="scrollable"
				scrollButtons="auto"
				sx={{ borderBottom: 1, borderColor: "divider", px: 1, flexShrink: 0 }}>
				{threadCatalogTabs.map((tab) => (
					<Tab key={tab.key} value={tab.key} label={`${tab.name}${kpi?.[tab.key] != null ? ` (${kpi[tab.key]})` : ""}`} />
				))}
			</Tabs>

			{threadCatalogTabs.map((tab) =>
				activeTab === tab.key ? (
					<CatalogTabPanel
						key={`${tab.key}-${refreshKey}`}
						apiBase={API_BASE}
						catalog={tab.key}
						columns={threadCatalogColumns[tab.key]}
						primaryKey={threadCatalogPrimaryKeys[tab.key]}
						editableFields={threadEditableFields[tab.key]}
						creatableFields={threadCreatableFields[tab.key]}
						autoPrimaryKey={threadAutoPrimaryKeyCatalogs.has(tab.key)}
						getRowId={getThreadRowId}
						refreshKey={refreshKey}
						onSummaryRefresh={handleSummaryRefresh}
					/>
				) : null,
			)}
		</Box>
	);
};

export default ThreadMaster;
